/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { PaginatedUserIdentifications } from './types';
import { apiClient } from '@/utils/apiClient';

export const fetchUserIdentifications = createAsyncThunk<
  PaginatedUserIdentifications,
  void,
  { rejectValue: string }
>('userIdentifications/fetchAll', async (_, { rejectWithValue }) => {
  try {
    const response = await apiClient('/auth/api/v1/user/identifications/', {
      method: 'GET',
    });
    return response as PaginatedUserIdentifications;
  } catch (err: any) {
    return rejectWithValue(
      err.message || 'Failed to load user identifications'
    );
  }
});
